import { Component, OnInit } from '@angular/core';
import {VnaCampaignService} from '../../services/vna-campaign.service';
import {ActivatedRoute, Router} from '@angular/router';
import {CampService} from '../../model/CampService';
import {VnaPortalSelected} from '../../../../../core/data/messaging/VnaPortalSelected';
import {MessagingService} from '../../../../../core/service/messaging.service';
import {Location} from '@angular/common';
import {VnaPbxConfigCreated} from '../../model/VnaPbxConfigCreated';

@Component({
  selector: 'app-edit-campaign',
  templateUrl: './edit-campaign.component.html',
  styleUrls: ['./edit-campaign.component.scss']
})
export class EditCampaignComponent implements OnInit {

    params: Object = {};
    enabled: boolean = false;
    campaign: CampService;

    constructor(private activatedRoute: ActivatedRoute,
                private campHandler: VnaCampaignService,
                private messaging:MessagingService,
                private location: Location,
                private router:Router) { }

    ngOnInit() {
        this.activatedRoute.params.subscribe(
            (params) => {
                this.params = params;
                this.enabled = true;
                this.campHandler.findMergedPortalCampaign(this.params['pkCamp']).subscribe(
                    (result) => {
                        this.campaign = new CampService(result);
                        this.enabled = false;
                    }
                )
            }
        );
        this.messaging.message.subscribe(
            (result) => {
                if(result instanceof VnaPortalSelected && !result.isTheFirst() && this.location.path().match(/phone\/config\/campaign/g)){
                    this.router.navigateByUrl('/phone/config/campaigns');
                }
            }
        )
    }
}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/vna-campaign/components/edit-campaign/edit-campaign.component.ts